export default "__VITE_ASSET__CgmZ22oC__"